<template>
  <el-select
    v-model="value"
    :size="size"
    filterable
    clearable
    style="width: 100%"
    @change="change"
    @clear="clear"
    :placeholder="placeholder"
    :no-data-text="
      !!custCode
        ? $l('INDEX.tips_select_nodata')
        : $l('INDEX.tips_select_feeCust')
    "
  >
    <el-option
      v-for="item in optionData"
      :key="item.orderCode"
      :label="item.custOrderNo"
      :value="item.orderCode"
    ></el-option>
  </el-select>
</template>

<script>
import { request } from '@/api/service'
export default {
  props: {
    custCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    custOrderNo: { type: String, default: '' },
    size: { default: 'small', type: String },
    placeholder: { type: String, default: 'Please select' },
  },
  data() {
    return {
      value: '',
      optionData: [],
    }
  },
  watch: {
    custCode: {
      async handler() {
        await this.loadData()
        this.setValue()
      },
      immediate: true,
    },
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.optionData.map((o) => [o.orderCode, o]))
    },
  },
  mounted() {
    this.value = this.orderCode
  },
  methods: {
    async loadData() {
      let data = []
      if (this.custCode) data = await this.getData()
      this.optionData = data
    },
    getData() {
      return request({
        url: '/factory/orderInfo/select',
        data: { custCode: this.custCode },
        method: 'POST',
      })
        .then((res) => ((res || {}).body || {}).data || [])
        .catch(() => [])
    },
    setValue() {
      if (!this.orderCode) {
        this.value = ''
        this.$emit('update:custOrderNo', '')
        return
      }
      const options = this.optionsMap[this.orderCode]
      if (!options) {
        this.value = ''
        this.$emit('update:orderCode', '')
        this.$emit('update:custOrderNo', '')
      }
    },
    change(e) {
      const options = this.optionsMap[e]
      if (!options) return
      const { orderCode, custOrderNo } = options
      this.$emit('update:orderCode', orderCode)
      this.$emit('update:custOrderNo', custOrderNo)
      this.$emit('change', options)
    },
    clear() {
      this.value = ''
      this.$emit('update:orderCode', '')
      this.$emit('update:custOrderNo', '')
    },
  },
}
</script>
